import React, { useMemo } from 'react';
import AddonSlot from '../ui/AddonSlot';
import OriginalSampleDetails from '../../src/apps/mydb/elements/details/samples/SampleDetails';

export default function SampleDetailsWrapper(props) {
  const { sample } = props;
  const sampleId = sample?.id ?? 0;
  const canUpdate = sample?.can_update === true;
  const showedName =
    typeof sample?.showed_name === 'string' && sample.showed_name.length > 0
      ? sample.showed_name
      : null;

  const mountProps = useMemo(
    () => ({ sampleId, canUpdate, showedName }),
    [sampleId, canUpdate, showedName],
  );

  const addonHeaderActions = (
    <AddonSlot
      name="SampleStickerLauncher"
      mountProps={mountProps}
      mountOptions={{ shadowDom: true }}
      remountDeps={[sampleId, canUpdate, showedName]}
      fallback={null}
    />
  );

  return (
    <OriginalSampleDetails
      {...props}
      showPrintCode={false}
      addonHeaderActions={addonHeaderActions}
    />
  );
}
